import React from 'react';
import classNames from 'classnames';

import './banner.css';

interface BannerProps extends React.HTMLAttributes<HTMLDivElement> {
  text?: string;
  type?: 'informational' | 'error' | 'warning' | 'marketing';
}

/**
 * @deprecated components/Banner is deprecated, use components/BannerV2
 */
const Banner: React.FC<BannerProps> = ({ text, type, children, ...rest }) => (
  <div className={classNames('zola-ui', 'banner', type)} {...rest}>
    {typeof text === 'string' ? text : children}
  </div>
);

Banner.defaultProps = {
  type: 'informational',
};

export default Banner;
